"use client";
import * as CheckboxRadix from "@radix-ui/react-checkbox";
import { Row } from "../Row";
import Balancer from "react-wrap-balancer";
import "./Checkbox.scss";
import clsx from "clsx";
import { Col } from "@/components";
import { CheckIcon } from "@/icons";

type CheckboxProps = {
  id: string;
  label?: React.ReactNode;
  checked: boolean;
  onChange: (checked: boolean) => void;
  classNameText?: string;
  linkText?: string;
  onPressLink?: () => void;
};

export const Checkbox = ({
  id,
  linkText,
  onPressLink,
  label,
  checked,
  onChange,
  classNameText = "fs-6 fw-bold",
}: CheckboxProps) => {
  const parser = new DOMParser();
  const html = parser.parseFromString(`${label}`, "text/html");
  const labelText = html?.body?.textContent || "";

  return (
    <Row
      alignItems={linkText ? "flex-start" : "center"}
      className={"ui-check-box-container"}
      gap="x16"
    >
      <CheckboxRadix.Root
        id={id}
        checked={checked}
        onCheckedChange={onChange}
        className={"ui-checkbox"}
        aria-label={labelText}
      >
        <CheckboxRadix.Indicator>
          <CheckIcon width={14} height={14} color="white" />
        </CheckboxRadix.Indicator>
      </CheckboxRadix.Root>
      <Col>
        {label && (
          <Balancer
            as="label"
            htmlFor={id}
            className={clsx(classNameText, "text-slate-20")}
          >
            {label}
          </Balancer>
        )}
        {linkText && (
          <Col onClick={onPressLink}>
            <span className={"ui-link-checkbox cursor-pointer"}>
              {linkText}
            </span>
          </Col>
        )}
      </Col>
    </Row>
  );
};
